module.exports = "/static/images/weddings.jpg";